module.exports = __webpack_public_path__ + "img/logo-11.7956d52c.png";